import styles from "./ContactCard.module.css";
import ContactThumbnailUrl from "/assets/contact-thumbnail.jpg";

export default function ContactCard({
  contact,
  locale,
}) {
  return (
    <div className={styles.card}>
      <img src={contact.photo?.url || ContactThumbnailUrl} />
      <div className={styles.info}>
        <span>{contact[`name_${locale}`]}</span>
        <ul>
          <li><span className="txt-gray-dark">telegram:</span> {contact.telegram_username}</li>
          <li><span className="txt-gray-dark">whatsapp:</span> {contact.whatsapp_number}</li>
          <li><span className="txt-gray-dark">email:</span> {contact.email}</li>
        </ul>
      </div>
    </div>
  );
}
